import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import { UploadFileOutlined } from '@mui/icons-material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointFileProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointFile: React.FC<CheckpointFileProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  // Value could be a file reference object or string
  const fileName = typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>).name as string | undefined
    : typeof value === 'string' ? value : undefined;

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {checkpoint.checkpointName}
        {checkpoint.required && <Typography component="span" color="error"> *</Typography>}
      </Typography>
      {checkpoint.referenceFile?.fileName && (
        <Typography variant="caption" color="text.secondary">
          Reference: {checkpoint.referenceFile.fileName}
        </Typography>
      )}
      {fileName ? (
        <Typography variant="body2" color="primary">{fileName}</Typography>
      ) : (
        <Box>
          <Button
            size="small"
            variant="outlined"
            startIcon={<UploadFileOutlined />}
            disabled={isReadOnly}
            sx={{ textTransform: 'none' }}
          >
            Upload File
          </Button>
        </Box>
      )}
      {error && (
        <Typography variant="caption" color="error">{error}</Typography>
      )}
    </Stack>
  );
};
